import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterManagerComponent } from './filter-manager.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FadeModule } from '../diagnostics/component/alert/fade/fade.module';
import { FilterListModule } from '../filterlist/filterlist.module';
import { AngularMaterialModule } from '../shared/module/angular-material.module';
import { ApplicationPipesModule } from '../shared/module/applicationPipesModule';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [FilterManagerComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    FadeModule,
    FilterListModule,
    ApplicationPipesModule,
    MatProgressBarModule,
    TranslateModule
  ],
  exports: [FilterManagerComponent]
})
export class FilterManagerModule { }
